module.exports = __webpack_public_path__ + "static/media/facebook-original.fd848883.svg";